var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "GridItem",
    {
      ref: "item",
      attrs: {
        x: _vm.x,
        y: _vm.y,
        w: _vm.w,
        h: _vm.h,
        i: _vm.i,
        static: _vm.edit
      }
    },
    [
      _c(
        "WidgetEditable",
        {
          directives: [
            {
              name: "clickoutside",
              rawName: "v-clickoutside",
              value: _vm.handleClickOutside,
              expression: "handleClickOutside"
            }
          ],
          attrs: { disabled: !_vm.editionMode },
          on: { edit: _vm.handleWidgetEdit, delete: _vm.handleWidgetDelete }
        },
        [
          _c(
            _vm.template,
            _vm._b(
              { tag: "component", on: { change: _vm.handleWidgetChange } },
              "component",
              Object.assign({}, _vm.$attrs, { edit: _vm.edit }),
              false
            )
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }